export const overlaySurfaceClassName =
  "bg-background/[0.92] backdrop-blur-md dark:bg-background/[0.72] dark:backdrop-blur-2xl";

export const dropdownSurfaceClassName =
  "bg-background/[0.92] backdrop-blur-md dark:bg-background/[0.72] dark:backdrop-blur-2xl";

export const popupSurfaceClassName =
  "bg-background/[0.96] backdrop-blur-sm dark:bg-background/90 dark:backdrop-blur-xl";
